export const MARKETS = {
  LOAD: 'MARKETS.LOAD',
  SWITCH: 'MARKETS.SWITCH',
}

export default MARKETS
